import React from 'react';
import { Link } from 'react-router-dom';
import '../Articles/Shared-Formatting.css';

function PaperReview1() {
  return (
    <div className="article-wrapper">
      <article className="article-container">
        <h1 className="article-title">RESA: Transparent Resoning Models via SAEs</h1>
        <div className="article-meta">
        <span>Last updated on: July 5th, 2025</span> | <span>Originally published on: July 5th, 2025</span> |  <span>Arxiv Link: <a href="https://arxiv.org/abs/2506.09967">https://arxiv.org/abs/2506.09967</a></span>
        </div>
        <div className="article-content">
          <p>
	  It looks like this paper centers around a method of transferring behaviors from one model to another using SAEs. 
          </p>
	  <p>Their method—as I understand it—is as follows:</p>
	  <ul>
	  <li>Gather a dataset of question-answer pair prompts</li>
	  <li>Run an existing reasoning model on these prompts, and store the activations</li>
	  <li>Train an SAE at a selected model component output using the stored activations. They use Top-k SAEs and train the SAEs on the output of transformer layers(so residual stream after the MLP)</li>
	  <li>Insert the SAE into a model that you want to bestow reasoning abilities upon(why? How does this work? It seems odd that latents would transfer across models like this). They limit this to pairs of models that have the same size/architecture, it seems like the main requirement is having the same residual stream size.</li>
	  <li>Gather a dataset of question-answer pairs, perhaps the same as the original dataset</li>
	  <li>Perform supervised fine tuning (They used LORA on the "elicitation dataset")with the SAE frozen</li>
	  <ul>
	  <li>Factor each parameter matrix into two low rank matrices</li>
	  <li>Do a forward pass with and without the SAEs, using the reproduced low rank matrices</li>
	  <li>Using KL divergence from the SAE assisted output, perform a backward pass on the plain LORA model</li>
	  <li>Update the low rank matrices with the gradient information</li>
	  </ul>
	  </ul>
	  <p>Further questions:</p>
	  <ul>
	  <li>This feels like it's not unique to reasoning abilities, what other behaviors could you transfer this way?</li>

	  </ul>
        </div>
        <footer className="article-footer">
          <p>Thanks for reading! Check out more articles in the <Link to="/paper-reviews">Paper Reviews</Link> section.</p>
        </footer>
      </article>
    </div>
  );
}

export default PaperReview1;
